import React from 'react';
// @ts-ignore
import logoInfoZumHaus from '../../assets/Logo_iZH_loading.svg';

const LoadingIconIZH = () => {
  return <img style={{ height: '48px' }} src={logoInfoZumHaus} alt="Alles rund um Ihr Haus" />;
};

export default LoadingIconIZH;
